import addStartupScript from '../events/addStartupScript';
import forEachElement from '../elements/forEachElement';
import { selectors } from './elements/constants';
import * as stepModel from './models/step';

/**
 * Adds event listeners to all form inputs to check for keydown events. This is instead of
 * addTargetEventListener because we do NOT want the event to bubble up to the document or form,
 * instead we want to catch it early and stop it.
 */
export function addKeyDownEventListeners() {
  const inputSelectors = selectors.fields.map(field => `${selectors.formField} ${field}`);
  forEachElement(document.querySelectorAll(inputSelectors.join()), input => {
    input.addEventListener('keydown', handleKeyDown);
  });
}

function handleKeyDown(event) {
  if(event.key === 'Enter') {
    handleKeyEnter(event);
  }
}

function handleKeyEnter(event) {
  const panel = stepModel.getStep(event.target);
  if(!stepModel.isActiveStep(panel)) { return; }

  const button = panel.querySelector(selectors.nextButton);
  if(button) {
    button.click();
    event.preventDefault();
    event.stopPropagation();
  }
}

addStartupScript(addKeyDownEventListeners);
